/* eslint-disable @typescript-eslint/no-unused-vars */
import type { ColumnDef } from "@tanstack/react-table";
import { BookingAuditMessage } from "@repo/database";

import "@tanstack/react-table";

export type ColumnDefWithTotal<TData, TValue = unknown> = ColumnDef<
  TData,
  TValue
> & {
  enableTotal?: boolean;
};

export interface VoysIncomingCall {
  callerId: string;
}

export function isColumnDefWithTotal<TData, TValue>(
  column: ColumnDef<TData, TValue>,
): column is ColumnDefWithTotal<TData, TValue> {
  return "enableTotal" in column && typeof column.enableTotal === "boolean";
}

export type PartialWithRequired<T, K extends keyof T> = Partial<T> &
  Required<Pick<T, K>>;

export type ManagerResult<TData, TError = { path: TData; message: string }> =
  | { error?: undefined; data: boolean }
  | { error: TError; data?: undefined };

export interface Report {
  date: Date;
  numberOfReceipts: number;
  customers: number;
  totalAmount: number;
  revenue: number;
  tips: number;
  vat: Record<string, number>;
  payments: Record<
    string,
    {
      amount: number;
      tip: number;
      quantity: number;
    }
  >;
}

export function isBookingAuditMessage(
  value: string,
): value is BookingAuditMessage {
  return (Object.values(BookingAuditMessage) as string[]).includes(value);
}

declare module "@tanstack/react-table" {
  interface ColumnMeta<TData, TValue> {
    canSelect?: boolean;
  }
}
